import { css } from '@emotion/css';
import React from 'react';
import { TwinkleStar, TwinkleStarProps } from './TwinkleStar';

export interface Star {
  position: { x: string; y: string };
  size?: number;
  color?: string;
  rest: number;
  duration: number;
}
interface TwinkleStarsProps {
  stars: Star[];
  delay?: number;
  style?: React.CSSProperties;
}

export const TwinkleStars: React.FC<TwinkleStarsProps> = ({ stars, delay, style, children }) => {
  const dataList = createTwinkleDataList(stars, delay);
  return (
    <div
      className={css`
        display: flex;
        position: relative;
      `}
      style={style}
    >
      {children}
      {dataList.map((data, i) => (
        <TwinkleStar
          key={`${i}`}
          size={data.size}
          color={data.color}
          rest={data.rest}
          duration={data.duration}
          whole={data.whole}
          style={data.style}
        />
      ))}
    </div>
  );
};

function createTwinkleDataList(stars: Star[], delayOffset?: number): TwinkleStarProps[] {
  const whole = stars.reduce((acc, s) => Math.max(acc, s.rest + s.duration), 0);
  const results: TwinkleStarProps[] = [];
  for (const star of stars) {
    if (star.position) {
      results.push({
        size: star.size || 36,
        color: star.color || '#FFBC00',
        rest: star.rest,
        duration: star.duration,
        whole,
        style: {
          position: 'absolute',
          left: star.position?.x,
          top: star.position?.y,
          transform: 'translate(-50%, -50%)',
          animationDelay: delayOffset ? `${delayOffset}ms` : 'none'
        }
      });
    }
  }

  return results;
}
